import React from "react";
import { Helmet } from 'react-helmet';
import { useState, useEffect } from "react";
import axios from "axios";
import { buildApiUrl } from "../utils/api";
function ProviderList() {
    const [totalProvider, settotalProviders] = useState(0);
    useEffect(() => {
        const fetchRequesterData = async () => {
            try {
                const providerRes = await axios.get(buildApiUrl('/api/getProviders'));
                settotalProviders(providerRes.data);
            }
            catch (error) {
                console.error('Error fetching data', error);
            }
        }
        fetchRequesterData();
    }, [])
    return (
        <>
            <Helmet>
                <title>3pl Provider | 3pl Site</title>
            </Helmet>
            <div className="providerList">
                <h1>3PL PROVIDERS LIST</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-striped table-hover">
                        <thead class="table-dark">
                            <tr>
                                <th>S.no</th>
                                <th>Name</th>
                                <th>E-mail</th>
                                <th>Contact Number</th>
                                <th>Firm Name</th>
                                <th>Location</th>
                                <th>Total Area</th>
                                <th>Service Provided</th>
                                <th>Serviceable Area</th>
                                <th>Additional Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalProvider.length > 0 ? (
                                totalProvider.map((provider, index) => (
                                    <tr key={provider._id}>
                                        <td>{index + 1}</td> {/* Serial number */}
                                        <td>{provider.name}</td> {/* Assuming `name` field */}
                                        <td>{provider.email}</td> {/* Assuming `email` field */}
                                        <td>{provider.contactNumber}</td> {/* Assuming `phone` field */}
                                        <td>{provider.firmName}</td> {/* Assuming `company` field */}
                                        <td>{provider.location}</td>
                                        <td>{provider.totalArea}</td>
                                        <td>{provider.serviceProvided}</td>
                                        <td>{provider.serviceableArea}</td>
                                        <td>{provider.summary}</td>
                                        {/* <td>{requester.summary}</td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No requesters found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
export default ProviderList
